/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileId } from './FileId';
import { FileIdFromJSON, FileIdFromJSONTyped, FileIdToJSON } from './FileId';
import type { PublishOn } from './PublishOn';
import { PublishOnFromJSON, PublishOnFromJSONTyped, PublishOnToJSON } from './PublishOn';
import type { Published } from './Published';
import { PublishedFromJSON, PublishedFromJSONTyped, PublishedToJSON } from './Published';

/**
 *
 * @export
 * @interface ProjectCreateModel
 */
export interface ProjectCreateModel {
    /**
     *
     * @type {string}
     * @memberof ProjectCreateModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ProjectCreateModel
     */
    content: string;
    /**
     *
     * @type {string}
     * @memberof ProjectCreateModel
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof ProjectCreateModel
     */
    author: string;
    /**
     *
     * @type {Published}
     * @memberof ProjectCreateModel
     */
    published?: Published;
    /**
     *
     * @type {PublishOn}
     * @memberof ProjectCreateModel
     */
    publishOn?: PublishOn;
    /**
     *
     * @type {FileId}
     * @memberof ProjectCreateModel
     */
    fileId?: FileId;
}

/**
 * Check if a given object implements the ProjectCreateModel interface.
 */
export function instanceOfProjectCreateModel(value: object): boolean {
    if (!('title' in value)) return false;
    if (!('content' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    return true;
}

export function ProjectCreateModelFromJSON(json: any): ProjectCreateModel {
    return ProjectCreateModelFromJSONTyped(json, false);
}

export function ProjectCreateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ProjectCreateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'],
        content: json['content'],
        type: json['type'],
        author: json['author'],
        published: json['published'] == null ? undefined : PublishedFromJSON(json['published']),
        publishOn: json['publish_on'] == null ? undefined : PublishOnFromJSON(json['publish_on']),
        fileId: json['file_id'] == null ? undefined : FileIdFromJSON(json['file_id']),
    };
}

export function ProjectCreateModelToJSON(value?: ProjectCreateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        content: value['content'],
        type: value['type'],
        author: value['author'],
        published: PublishedToJSON(value['published']),
        publish_on: PublishOnToJSON(value['publishOn']),
        file_id: FileIdToJSON(value['fileId']),
    };
}
